import { render, staticRenderFns } from "./joinPage.vue?vue&type=template&id=1ee2f28e&scoped=true&"
import script from "./joinPage.vue?vue&type=script&lang=js&"
export * from "./joinPage.vue?vue&type=script&lang=js&"
import style0 from "./joinPage.vue?vue&type=style&index=0&id=1ee2f28e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ee2f28e",
  null
  
)

export default component.exports